import { useStore } from '../admin/context/ProductStore';
import { AlertCircle } from 'lucide-react';
import './MaintenanceOverlay.css';

export default function MaintenanceOverlay() {
  const { maintenanceMode } = useStore();

  if (!maintenanceMode) return null;

  return (
    <div className="maintenance-overlay">
      <div className="maintenance-card">
        <div className="maintenance-icon">
          <AlertCircle size={48} />
        </div>
        <h2 className="maintenance-title">Orders Paused</h2>
        <p className="maintenance-text">
          🔥 Experiencing exceptionally high demand right now. 
          Current order slots are fully allocated while we manage incoming requests.
        </p>
        <div className="maintenance-footer">
          <p>We'll be back shortly! Stay tuned.</p>
        </div>
      </div>
    </div>
  );
}
